module.exports = __webpack_public_path__ + "img/logo.e73a253c.png";